<script>
import icons from './icons'

export default {
  functional: true,

  name: 'icon',

  props: ['type'],

  render(h, ctx) {
    function appropriateIconComponent() {
      return icons[ctx.props.type]
    }

    return h(
      appropriateIconComponent(),
      ctx.data,
      ctx.children
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/icon.vue